import styled from 'styled-components'

import { theme } from 'styles/theme'

const { borderWidths, colors, radii, space } = theme

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 101;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgb(255 255 255 / 67%);
  border-radius: 1rem;
`

export const FormFallback = styled.div`
  display: grid;
  gap: ${space['spacing-xxs']};
  padding: ${space['spacing-sm']};
  border: ${borderWidths['border-stroke-micro']} solid ${colors['neutral-border-default']};
  border-radius: ${radii['corner-radius-sm']};
`
